export default {
    methods: {
        showActivationDialog(system = null) {
            this.$modal.show(
                () => import('@/views/modal/ActivateSystem.vue'),
                {
                    system: system,
                },
                {
                    name: 'ActivateSystem',
                    scrollable: true,
                    width: 450,
                    height: 'auto',
                    class: 'ngdialog-theme-winconnect',
                }
            );
        },
    },
};
